import { useMemo } from 'react';
import { useInstallPermissions } from '../contexts/InstallPermissionsContext';
import { applyDeltaToSet } from '../contexts/InstallPermissionsContext';
export function buildUserTeamMap(teams, selectedTeamIds) {
  const map = new Map();
  function processTeams(teamList) {
    for (const team of teamList) {
      if (selectedTeamIds.has(team.id)) {
        const allUserIds = [...team.userIds, ...team.secondaryUserIds];
        for (const userId of allUserIds) {
          const existing = map.get(userId);
          if (existing) {
            existing.push(team.name);
          } else {
            map.set(userId, [team.name]);
          }
        }
      }
      if (team.childTeams.length > 0) {
        processTeams(team.childTeams);
      }
    }
  }
  processTeams(teams);
  return map;
}
export function useUserTeamAccess(fatTeams) {
  const {
    initialTeamIds,
    updatedTeams
  } = useInstallPermissions();
  return useMemo(() => {
    const selectedTeamIds = applyDeltaToSet(initialTeamIds, updatedTeams);
    if (selectedTeamIds.size === 0) {
      return new Map();
    }
    return buildUserTeamMap(fatTeams, selectedTeamIds);
  }, [fatTeams, initialTeamIds, updatedTeams]);
}